<footer class="shadow dark:shadow-gray-700 bg-white dark:bg-slate-900 px-6 py-4">
    <div class="container-fluid">
        <div class="grid grid-cols-1">
            <div class="sm:text-start text-center mx-md-2">
                <p class="mb-0 text-sm text-slate-400">© {{date}} CrickTeams. Design & Develop by <a href="https://nextgnsolutions.com" class="text-reset" target="_blank" style="text-decoration: underline;">NextGen Solutions & Services LLC</a></p>
            </div><!--end col-->
        </div><!--end grid-->
    </div><!--end container-->
</footer>
